import { useAtom } from "jotai";
import { useCallback } from "react";

import {
  currentQuestionIndexAtom,
  landerQuizQuestionAtom,
} from "../../../lander-quiz.state";
import { QuestionTitle } from "../../shared/question-title/question-title.component";

export const InputQuestion: React.FC = () => {
  const [currentQuestionIndex] = useAtom(currentQuestionIndexAtom);
  const [currentQuestion, setCurrentQuestion] = useAtom(
    landerQuizQuestionAtom(currentQuestionIndex)
  );

  const handleInputChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setCurrentQuestion({
        ...currentQuestion,
        answer: e.target.value || null,
      });
    },
    [currentQuestion, setCurrentQuestion]
  );

  return (
    <div className="input-question">
      <QuestionTitle title={currentQuestion.title} />
      <div className="input-question__input-container">
        <input
          type="text"
          className="input-question__input"
          placeholder="Type your response..."
          onChange={handleInputChange}
        />
      </div>
    </div>
  );
};
